import { render } from "./offerCard.vue?vue&type=template&id=62ca8cd5&scoped=true"
import script from "./offerCard.vue?vue&type=script&lang=js"
export * from "./offerCard.vue?vue&type=script&lang=js"

import "./offerCard.vue?vue&type=style&index=0&id=62ca8cd5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ca8cd5"]])

export default __exports__